import { __decorate } from "tslib";
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ImageUploadMixin from '@/helpers/vue_mixins/v2/ImageUploadMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
import Uploader from '@/components/v2/Uploader';
import { isNotEmpty } from '@/helpers';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import { requiredProperty, successfulCreate } from '@/helpers/mixins/LocalizationHelper';
import { required, maxLength } from 'vuelidate/lib/validators';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import ActionButton from '@/components/action_button/Index.vue';
import InviteSubscriberPreview from '@/components/v3/inbox_manager/InviteSubscriberPreview.vue';
import CreateSubscriptionInvitation from '@/plugins/graphql/mutations/copilot_inbox_manager/create-subscription-invitation.gql';
import EditSubscriptionInvitation from '@/plugins/graphql/mutations/copilot_inbox_manager/edit-subscription-invitation.gql';
import BaseOverlayLoader from '@/components/v2/BaseOverlayLoader';
import { Mutation } from 'vuex-class';
import { NAV_DRAWER } from '@/helpers/constants/app';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import FetchPriorityProducts from '@/plugins/graphql/queries/v2/copilot_inbox_manager/priority-products.gql';
import FetchExistingInvitation from '@/plugins/graphql/queries/v2/copilot_inbox_manager/subscription-invitation.gql';
import { FileUploadInputModel } from '@/helpers/entities/models/FileUploadInputModel';
import InvitationUploadImage from '@/plugins/graphql/mutations/copilot_inbox_manager/upload-invitation-image.gql';
import InvitationRemoveImage from '@/plugins/graphql/mutations/copilot_inbox_manager/remove-invitation-image.gql';
import { PhotoModel } from '@/helpers/entities/models/PhotoModel';
const maxCharacters = 2000;
let InviteSubscriber = class InviteSubscriber extends Mixins(FormMixin, ViewportSizeMixin, RouterParamsAppMixin, FormValidationsMixin, Mixins(AlertMixin, ImageUploadMixin, WindowSizeListener)) {
    constructor() {
        super(...arguments);
        this.existingInvitation = null;
        this.showInvitationForm = true;
        this.showInvitationPreview = true;
        this.newData = false;
        this.form = {
            image: [],
            title: 'Updates and promotions',
            greeting: 'Stay ahead with exclusive updates! Subscribe now for the latest trends, special offers, and more.',
            voucher: '',
            payload: this.payloadText,
            buttonCaption: 'See Latest Offers',
            selectedSubscribersOptions: [],
        };
        this.priorityProducts = [];
        this.isProvideOfferOptions = false;
        this.fileExceeded = false;
        this.hasRejectedFiles = false;
        this.mutationRequestOnFlight = false;
        this.confirmInviteSubscriber = false;
        this.vouchers = [
            {
                text: 'Voucher 1',
                value: 'voucher1',
            },
            {
                text: 'Voucher 2',
                value: 'voucher2',
            },
        ];
        this.automaticInviteSubscribersOptions = [
            {
                text: 'Triggered a comment auto-reply',
                value: 'comment_reply',
            },
            {
                text: 'Post Purchase',
                value: 'post_purchase',
            },
            {
                text: 'Triggered a ref link',
                value: 'ref_link',
            },
            {
                text: 'Triggered cart abandonment reminder',
                value: 'cart_reminder',
            },
            // {
            //   text: 'Triggered a Click-to-Messenger Ad',
            //   value: 'messenger_ad',
            // },
            {
                text: 'Triggered payment reminder',
                value: 'payment_reminder',
            },
        ];
        this.saving = false;
    }
    onResize() {
        if (this.window.width < 1025) {
            this.openInviteForm();
        }
        else {
            this.showInvitationForm = true;
            this.showInvitationPreview = true;
        }
    }
    openInviteForm() {
        if (this.window.width < 1025) {
            this.showInvitationForm = true;
            this.showInvitationPreview = false;
        }
    }
    // For Tablet and Mobile View
    openInvitePreview() {
        if (this.window.width < 1025) {
            this.showInvitationForm = false;
            this.showInvitationPreview = true;
        }
    }
    goBack() {
        this.openInviteForm();
    }
    get checkImageUnshow() {
        if (this.form.image.length) {
            const imageStates = this.form.image.map((image) => image.state);
            if (imageStates.every((state) => state === 'deleted')) {
                return false;
            }
            if (imageStates.some((state) => state === 'new' || state === 'idle')) {
                return true;
            }
        }
        return false;
    }
    get payloadText() {
        if (this.isProvideOfferOptions) {
            return 'Thank you for subscribing! 🎉 Enjoy an exclusive [discount amount] discount on your next purchase—automatically applied at checkout!\n\nStay tuned for updates, offers, and more.';
        }
        return `Thank you for subscribing. We're excited to share our latest offerings with you. We hope you find something you like. Stay tuned for updates and exclusive offers.`;
    }
    goToMessengerNotification() {
        this.$router.push({
            name: 'messenger-notification',
            params: { uuid: this.appUUID, to: 'messenger-notification' },
        });
    }
    get selectedOptionsText() {
        return this.form.selectedSubscribersOptions.map((option) => option.text).join(', ');
    }
    // Method to get selected values
    getSelectedValues() {
        return this.form.selectedSubscribersOptions.map((option) => option.value);
    }
    // Method to check if a specific option is selected
    isOptionSelected(value) {
        return this.form.selectedSubscribersOptions.some((option) => option.value === value);
    }
    onIsProvideOfferOptionsChange() {
        if (!this.isProvideOfferOptions) {
            this.form.voucher = '';
            this.form.payload =
                'Thank you for subscribing! 🎉 Enjoy an exclusive [discount amount] discount on your next purchase—automatically applied at checkout!\n\nStay tuned for updates, offers, and more.';
        }
        else {
            this.form.payload = `Thank you for subscribing. We're excited to share our latest offerings with you. We hope you find something you like. Stay tuned for updates and exclusive offers.`;
        }
    }
    get messageLimit() {
        return maxCharacters;
    }
    toggleProvideOfferOptions() {
        this.isProvideOfferOptions = !this.isProvideOfferOptions;
    }
    get greetingErrors() {
        const errors = [];
        if (!this.$v.form.greeting.$dirty) {
            return errors;
        }
        if (!this.$v.form.greeting.required) {
            const msg = requiredProperty('Invite Subscriber Greeting');
            errors.push(msg);
        }
        return errors;
    }
    get buttonCaptionErrors() {
        const errors = [];
        if (!this.$v.form.buttonCaption.$dirty) {
            return errors;
        }
        if (!this.$v.form.buttonCaption.required) {
            const msg = requiredProperty('Button Caption');
            errors.push(msg);
        }
        return errors;
    }
    get optionsErrors() {
        const errors = [];
        // Ensure the validation object is dirty (i.e., has been interacted with)
        if (!this.$v.form.selectedSubscribersOptions?.$dirty) {
            return errors;
        }
        // Check if the required validation has failed
        if (!this.$v.form.selectedSubscribersOptions?.required) {
            const msg = requiredProperty('Automatic Options');
            errors.push(msg);
        }
        return errors;
    }
    checkRejectedFiles() {
        const self = this;
        this.hasRejectedFiles = !!self.$refs.uploader.getRejectedFiles().length;
    }
    fileExceed() {
        this.fileExceeded = true;
        this.checkRejectedFiles();
        this.errorNotification('Exceeded total Number of files');
    }
    toggleConfirmation() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.confirmInviteSubscriber = true;
        }
    }
    onCancel() {
        this.confirmInviteSubscriber = false;
    }
    async onSubmit() {
        const mutation = () => this.existingInvitation ? this.editInvitation() : this.createInvitation();
        await await mutation()
            .then(async ({ data }) => {
            const invitationUuid = data?.createSubscriptionInvitation?.invitation?.uuid ||
                data?.editSubscriptionInvitation?.invitation?.uuid;
            if (isNotEmpty(this.form.image.length)) {
                // this.uploadingOnProgress();
                const deletedImagesUuids = this.getDeletedImageUuids(this.form.image);
                const newImages = this.filterNewImages(this.form.image);
                if (isNotEmpty(newImages.length)) {
                    await this.invitationImageUploader(invitationUuid, newImages);
                }
                if (isNotEmpty(deletedImagesUuids.length)) {
                    await this.removeInvitationImages(invitationUuid, deletedImagesUuids);
                }
                // this.uploadingDone();
            }
            const msg = successfulCreate('Notification');
            this.successNotification(msg);
            await this.$apollo.queries.existingInvitation?.refetch();
            // this.goToProductsPage();
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            // this.requestDone();
            this.$router.push({ name: 'messenger-notification' });
        });
        this.confirmInviteSubscriber = false;
        this.saving = false;
    }
    mounted() {
        this.showInbox(true);
    }
    async createInvitation() {
        const vm = this;
        vm.saving = true;
        const methods = vm.form.selectedSubscribersOptions.map((option) => option.value);
        return this.$apollo
            .mutate({
            mutation: CreateSubscriptionInvitation,
            variables: {
                input: {
                    appUuid: vm.appUUID,
                    title: vm.form.title,
                    greetingText: vm.form.greeting,
                    payload: vm.form.payload,
                    buttonText: vm.form.buttonCaption,
                    withPromo: this.isProvideOfferOptions,
                    methods,
                },
            },
        })
            .catch((e) => {
            console.error(e.message);
            this.errorNotification(e.message);
        });
    }
    async editInvitation() {
        const vm = this;
        vm.saving = true;
        const methods = vm.form.selectedSubscribersOptions.map((option) => option.value);
        return this.$apollo
            .mutate({
            mutation: EditSubscriptionInvitation,
            variables: {
                input: {
                    appUuid: vm.appUUID,
                    title: vm.form.title,
                    greetingText: vm.form.greeting,
                    payload: vm.form.payload,
                    buttonText: vm.form.buttonCaption,
                    withPromo: this.isProvideOfferOptions,
                    methods,
                },
            },
        })
            .catch((e) => {
            console.error(e.message);
            this.errorNotification(e.message);
        });
    }
    async invitationImageUploader(invitationUuid, images) {
        const inputImages = images.map((input) => input.file);
        await this.$apollo.mutate({
            mutation: InvitationUploadImage,
            variables: {
                input: {
                    subscriptionInvitationUuid: invitationUuid,
                    images: inputImages,
                },
            },
        });
    }
    async removeInvitationImages(subscriptionUuid, imageUuids) {
        await this.$apollo.mutate({
            mutation: InvitationRemoveImage,
            variables: {
                input: {
                    subscriptionInvitationUuid: subscriptionUuid,
                    photos: imageUuids,
                },
            },
        });
    }
    destroyed() {
        this.showInbox(false);
    }
    get showImage() {
        // return !!this.existingInvitation && !!this.form.image.length && !this.newData;
        return !this.newData;
    }
    get isNewData() {
        return this.newData;
    }
};
__decorate([
    Mutation('showInbox', { namespace: NAV_DRAWER })
], InviteSubscriber.prototype, "showInbox", void 0);
__decorate([
    Watch('window.width')
], InviteSubscriber.prototype, "onResize", null);
__decorate([
    Watch('isProvideOfferOptions')
], InviteSubscriber.prototype, "onIsProvideOfferOptionsChange", null);
InviteSubscriber = __decorate([
    Component({
        components: {
            Uploader,
            BaseImagePlaceholder,
            BaseTextField,
            BaseTextArea,
            ActionButton,
            InviteSubscriberPreview,
            ToggleConfirmationDialog,
            BaseOverlayLoader,
        },
        apollo: {
            priorityProducts: {
                query: FetchPriorityProducts,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                update(data) {
                    return data.fetchPriorityEcommerceProducts.edges.map(({ node }) => {
                        return node;
                    });
                },
            },
            existingInvitation: {
                query: FetchExistingInvitation,
                variables() {
                    return {
                        appUuid: this.appUUID,
                    };
                },
                // fetchPolicy: 'cache-and-network',
                update(data) {
                    const invitation = data.fetchSubscriptionInvitation;
                    if (invitation) {
                        this.newData = false;
                        const photoNode = (photo) => new PhotoModel(photo.node);
                        const photos = invitation.galleryPhotos.edges.map(photoNode);
                        const image = photos.map((photo) => new FileUploadInputModel(photo));
                        this.isProvideOfferOptions = invitation.withPromo;
                        const selectedOptions = this.automaticInviteSubscribersOptions.filter((option) => invitation.automaticOptions.includes(option.value));
                        this.form.title = invitation.title;
                        this.form.greeting = invitation.greetingText;
                        this.form.payload = invitation.payload;
                        this.form.buttonCaption = invitation.buttonText;
                        this.form.selectedSubscribersOptions = selectedOptions;
                        this.form.image = image;
                    }
                    else {
                        this.newData = true;
                    }
                    return data.fetchSubscriptionInvitation;
                },
            },
        },
        validations() {
            return {
                form: {
                    title: {
                        required,
                    },
                    greeting: {
                        required,
                    },
                    payload: {
                        required,
                        maxLength: maxLength(maxCharacters),
                    },
                    buttonCaption: {
                        required,
                    },
                    selectedSubscribersOptions: {
                        required,
                    },
                },
            };
        },
    })
], InviteSubscriber);
export default InviteSubscriber;
